<template>
  <div class="news-feed-component">
      <span class="back-arrow-main" @click="goTo('/me')">
          <img src="../../static/images/back-arrow-main.svg" alt="">
          <p>Back</p>
      </span>
      <!-- <p class="heading">News Feed</p> -->
      <div class="news-posts df fdc">
          <!-- <div class="news-post df fdc" v-for="(post, postid) in news"> -->
          <div class="news-post df fdc">
              <img :src="news.image" alt="" class="post-thumbnail">
              <div class="post-meta df fdc">
                  <p class="post-title">
                      {{news.title}}
                  </p>
                  <span class="df jcfs post-posted-by">
                      <span class="df">
                        <p class="by-posted-by">Posted by:</p>
                        <p class="by-by">By:</p>
                        <a class="post-username">{{news.author}}</a>
                      </span>
                      <span class="df">
                        <p class="separator">|</p>
                        <p class="post-date">{{date()}}</p>
                      </span>
                  </span>
                  <!-- <span class="df post-comments">
                      <i></i>
                      <p>{{'10'}} comments</p>
                  </span> -->
                  <span class="post-short temp_s1" v-html="newsPost()">
                      <!-- {{post()}} -->
                      <!-- {{post()}} -->
                  </span>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import router from '@/router'
import common from '@/util/common'

export default {
  name: 'NewsPost',
  data () {
    return {
        news: {}
    }
  },
  props: [],
  components: {

  },
  methods: {
      newsPost () {
        return this.news.post
      },
      goTo (path) {
          router.push(path)
      },
      date () {
        return common.formatDate2(this.news.date)
      },
      post () {
        return this.news.post || ''
      },
      getMyNews () {
        if (this.$store.getters['AUTH.uid']) {
          this.$store.dispatch('AUTH.getMyNews', {}).then((res) => {
            console.log('news2', res)
            let postid = this.$route.params.postid
            let post = res.filter(v => {
                return v.postid == postid
            })
            this.news = post[0]
          })
      } else {
        console.log('wait')
        setTimeout(() => {
          this.getMyNews()
        }, 500)
      }
    }
  },
  computed: {

  },
  created () {
      this.getMyNews()
  }
}
</script>

<style scoped lang="scss">
    @import "../styles/_colors.scss";

    .temp_s1 {
        margin-top: 8px;
    }

    .news-feed-component {
        width: 100%;
        max-width: 630px;
    }
    p {
        font-family: Inter;
    }
    .heading {
        color: #5C5C5C;
        font-family: Inter;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 20px;
        margin-bottom: 30px;
        // margin-top: 20px;
    }
    .news-post {
        margin-bottom: 34px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .post-thumbnail {
        width: 100%;
        max-width: 470px;
        height: 260px;
        /*background-color: #D8D8D8;*/
        margin-right: 30px;
        margin-bottom: 15px;
        object-fit: cover;
    }
    .post-title {
        color: #000000;
        font-family: Inter;
        font-weight: 700;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 25px;
    }
    .post-comments {
        color: #5C5C5C;
        font-family: Inter;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 13px;
        margin-top: 4px;
        margin-bottom: 13px;
    }
    .post-posted-by {
        a {
            margin-left: 4px;
        }
        & > p {
            // &:nth-child(2) {
                // margin-left: 4px;
            // }
            &:nth-of-type(2) {
            }
        }
    }
    .separator {
        font-weight: 600;
        margin-left: 8px;
        margin-right: 8px;
    }
    .post-posted-by, a {
        color: #000000;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 25px;
    }
    .post-short {
        color: #5C5C5C;
        font-family: Inter;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
        font-size: 14px;
        p {

        }
    }
    .post-short p {
      margin-bottom: 20px;
    }
    .post-short > * {
      padding-bottom: 20px;
    }
    a {
        font-weight: 700;
        color: #27C8B3;
    }
    @media (max-width: 800px) {
        .post-thumbnail {
            width: 100%;
            height: 220px;
            margin-bottom: 15px;
        }
        .news-post {
            flex-direction: column;
        }
    }
    @media (max-width: 395px) {
        .post-thumbnail {
            height: 170px;
        }
    }

    .by-by {
        display: none;
    }

    @media (max-width: 425px) {
        .by-posted-by {
            display: none;
        }
        .by-by {
            // display: block;
        }
        .post-posted-by {
            flex-direction: column;
        }
        .separator {
            display: none;
        }
        .post-date {
            line-height: 16px;
            font-size: 12px;
        }
        .post-username {
            margin-left: 0 !important;
        }
    }

    .contact-link {
      font-weight: 500;
    }
</style>



// WEBPACK FOOTER //
// src/components/NewsPost.vue